import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { SidebarInset, useSidebar } from "@/uiComponents/components/ui/sidebar";

import { ROUTES } from "@/enums/routes";

import { SidebarTrigger } from "@/uiComponents/components/ui/sidebar";
import { Avatar, AvatarFallback } from "@radix-ui/react-avatar";
import { useSelector } from "react-redux";
import { RootState } from "@/store/store";

interface AppHeaderProps {
  action?: React.ReactNode;
}

export function AppHeader({ action }: AppHeaderProps) {
  const { state } = useSidebar();
  const isCollapsed = state === "collapsed";
  return (
    <header className="sticky top-0 z-40 flex h-14 w-full items-center border-b bg-sidebar px-4">
      <div className="flex w-full items-center justify-between">
        {isCollapsed && (
          <div>
            <SidebarTrigger className="rounded-md hover:bg-gray-200 cursor-pointer" />
          </div>
        )}
        <div className="flex items-center gap-4"></div>

        <div className="flex items-center gap-4">
          {action}
          {/* Always show trigger on mobile */}
          <div className="md:hidden">
            <SidebarTrigger className="p-1.5 rounded-md hover:bg-gray-200 cursor-pointer" />
          </div>
        </div>
      </div>
    </header>
  );
}

export default function MainLayout() {
  const userDetails = useSelector(
    (state: RootState) => state.userDetail.userDetail,
  );

  const navigate = useNavigate();
  if (!userDetails) {
    return null;
  }
  const userAvatar = (
    <div
      className="flex gap-2 mr-2  rounded-xl cursor-pointer"
      onClick={() => navigate(ROUTES.PROFILE)}
    >
      <div className="flex">
        <Avatar className="rounded-full bg-[#25ae61] w-8 h-8 ">
          <AvatarFallback className="text-white font-semibold text-sm w-full h-full flex items-center justify-center">
            {userDetails?.username?.charAt(0).toUpperCase()}
          </AvatarFallback>
        </Avatar>
      </div>
      <div className="flex flex-col">
        <span className="mt-1 font-medium">{userDetails?.username}</span>
      </div>
    </div>
  );

  return (
    <div className="flex h-screen flex-col">
      {location.pathname !== "/organizationForm" && (
        <AppHeader action={userAvatar} />
      )}

      <SidebarInset className="flex-1 overflow-auto p-4">
        <Outlet />
      </SidebarInset>
    </div>
  );
}
